import { AgGridReact } from 'ag-grid-react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import { reduce, keys, delay, each, capitalize } from 'lodash';
import CustomHeader from '../../../../components/god-table/header';
import SearchField from '../../../../components/search-field';
import { fetchTVCollectorMappings, updateTVCollectorMappings } from '../../SetupActions';
import { getTVCollectorMappings, getTVCollectorRefs } from '../../SetupReducer';
import ProgressBar from '../../../../components/progress-bar';
import { getViewableDimensions } from '../../../App/AppReducer';
import styles from './styles.css';
import styles2 from '../../../Nomination/components/nav/styles.css';

function renderType(type) {
  let l = type;
  if (type === 'Win Loss') {
    l = 'wl';
  } else if (type === 'Customer Experience') {
    l = 'ce';
  } else if (type === 'Voice of the Buyer') {
    l = 'vb';
  } else if (type === 'Market Research') {
    l = 'mr';
  }
  return (<span className={`${styles2.type} ${styles2[l]}`}>{l}</span>);
}

function GroupRowInnerRenderer({ value }) {
  return (
    <strong className="text-uppercase">{renderType(value)}{value}</strong>
  );
}

GroupRowInnerRenderer.propTypes = {
  value: PropTypes.string,
};
GroupRowInnerRenderer.defaultProps = {
  value: null,
};

function CollectorCellRenderer(params) {
  const {
    value, data, context: { refs }, valid,
    colDef: { cellRendererParams: { mappingType } },
  } = params;
  if (!valid) {
    return (<span className="text-muted" style={{ cursor: 'not-allowed' }}>N/A</span>);
  }
  let display = value;
  const clientId = data.client_id;
  const programId = data.id;

  let values = null;
  if (refs[clientId] && refs[clientId][programId]) {
    values = refs[clientId][programId];
  }
  if (value && values) {
    values = refs[clientId][programId];
    const val = values[value];
    if (val) {
      display = val;
    }
  }

  let cls = display !== null ? 'text-active' : 'text-danger';
  if (!display) {
    if (keys(values).length === 0) {
      display = (<span style={{ cursor: 'not-allowed' }}><Fa name="exclamation-triangle" /> Missing collector in TruVoice</span>);
    } else {
      display = `[Select default ${mappingType} collector]`;
      cls = 'text-warning';
    }
  }
  return (<div className={`${cls} ${styles.cell}`}>{display}</div>);
}

class MappingTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loaded: false,
    };
    this.onGridReady = this.onGridReady.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.valueSetter = this.valueSetter.bind(this);
    this.columnCellRendererSelector = this.columnCellRendererSelector.bind(this);
    this.cellEditorSelector = this.cellEditorSelector.bind(this);
    this.checkCellEditable = this.checkCellEditable.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.fetchData();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  fetchData() {
    this.setState({ loading: true, loaded: false });
    this.props.dispatch(fetchTVCollectorMappings())
      .then(
        () => {
          if (this.mounted) {
            this.setState({ loading: false, loaded: true });
            delay(() => {
              if (this.gridApi) {
                this.gridApi.sizeColumnsToFit();
              }
            }, 500);
          }
        },
        () => {
          if (this.mounted) {
            this.setState({ loading: false, loaded: false });
          }
        },
      );
  }

  valueSetter(params) {
    const { data, newValue, colDef: { cellRendererParams: { mappingType } } } = params;
    const submitParams = {
      client_id: data.client_id,
      program_id: data.id,
      collector_id: newValue,
      type: mappingType,
    };
    this.props.dispatch(updateTVCollectorMappings(submitParams))
      .then(
        () => {
          if (this.gridApi) {
            this.gridApi.refreshCells({ force: true });
            this.gridApi.refreshClientSideRowModel('aggregate');
            const node = this.gridApi.getRowNode(`${data.client_id}|${data.program_id}`);
            if (node) {
              this.gridApi.flashCells({ rowNodes: [node] });
            }
          }
        },
        (e) => {
          const { message } = (e.data || e);
          if (message) {
            const el = (
              <div>{message}</div>
            );
            this.context.addNotification(el, { type: 'error', autoClose: false });
          }
        },
      );
    return true;
  }

  handleSearch(query) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(query);
    }
  }

  checkEditable(programType, mappingType) {
    let valid = false;
    if (programType === 'Win Loss' && mappingType === 'decision') {
      valid = true;
    } else if (programType === 'Customer Experience' && mappingType === 'experience') {
      valid = true;
    } else if (programType === 'Voice of the Buyer' && (mappingType === 'decision' || mappingType === 'experience')) {
      valid = true;
    }
    return valid;
  }

  columnCellRendererSelector(params) {
    if (!params) {
      return null;
    }
    const { data, colDef: { cellRendererParams } } = params;
    const programType = data.type_name;
    const { mappingType } = cellRendererParams;
    const valid = this.checkEditable(programType, mappingType);

    return {
      component: 'collectorCellRenderer',
      params: {
        valid,
      },
    };
  }

  checkCellEditable(params) {
    if (!params) {
      return null;
    }

    const { refs } = this.props;
    const { data, colDef: { cellRendererParams } } = params;
    const programType = data.type_name;
    const { mappingType } = cellRendererParams;
    const valid = this.checkEditable(programType, mappingType);
    const clientId = data.client_id;
    const programId = data.id;
    let values = {};
    if (refs[clientId] && refs[clientId][programId]) {
      values = refs[clientId][programId];
    }

    return valid && keys(values).length > 0;
  }

  cellEditorSelector(params) {
    if (!params) {
      return null;
    }
    const { data } = params;
    const { refs } = this.props;
    const clientId = data.client_id;
    const programId = data.id;
    let values = {};
    if (refs[clientId] && refs[clientId][programId]) {
      values = refs[clientId][programId];
    }
    return {
      component: 'agRichSelectCellEditor',
      params: {
        values: [...keys(values), null],
        formatValue: value => values[value] || '[exclude]',
      },
    };
  }

  renderContent() {
    const {
      mappings,
      refs,
      viewableDimensions: { height },
    } = this.props;
    const columnDefs = [
      {
        field: 'type_name',
        headerName: 'Program Type',
        suppressMenu: true,
        rowGroup: true,
        rowGroupIndex: 0,
        hide: true,
      },
      {
        field: 'name',
        headerName: 'Program',
        suppressMenu: true,
      },
      ...((['decision', 'experience']).map(mappingType => ({
        field: `${mappingType}_collector_id`,
        headerName: `Default ${capitalize(mappingType)} Collector`,
        valueSetter: this.valueSetter,
        suppressMiniFilter: true,
        suppressSorting: true,
        suppressMenu: true,
        cellRendererParams: {
          mappingType,
        },
        editable: this.checkCellEditable,
        singleClickEdit: true,
        cellRendererSelector: this.columnCellRendererSelector,
        cellEditorSelector: this.cellEditorSelector,
      }))),
    ];
    return (
      <div>
        <nav className="navbar navbar-default navbar-controls">
          <form className="navbar-form navbar-left">
            <SearchField onSearch={this.handleSearch} />
          </form>
        </nav>
        <div className={`ag-theme-balham ${styles.table}`} style={{ height, width: '100%' }}>
          <AgGridReact
            reactNext
            context={{ refs }}
            enableColResize
            enableSorting
            suppressCellSelection
            animateRows
            groupUseEntireRow
            groupDefaultExpanded={-1}
            groupRowInnerRenderer="groupRowInnerRenderer"
            columnDefs={columnDefs}
            getRowNodeId={data => `${data.client_id}|${data.program_id}`}
            onGridReady={this.onGridReady}
            rowData={mappings}
            rowHeight={34}
            frameworkComponents={{
              agColumnHeader: CustomHeader,
              collectorCellRenderer: CollectorCellRenderer,
              groupRowInnerRenderer: GroupRowInnerRenderer,
            }}
          />
        </div>
      </div>
    );
  }

  renderInstruction() {
    return (
      <div className="well well-sm">
        Select the default survey collector to use for each TruVoice program:
      </div>
    );
  }

  render() {
    const { loading, loaded } = this.state;
    const { hasCollector } = this.props;
    const isLoading = loading || !loaded;
    if (isLoading) {
      return (<ProgressBar />);
    }
    if (!hasCollector) {
      return (
        <div className="alert alert-danger">
          <Fa name="exclamation-triangle" /> No Survey Collectors found for this organization.
        </div>
      );
    }
    return (
      <div>
        {this.renderInstruction()}
        {this.renderContent()}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const clients = getTVCollectorMappings(state);
  const mappings = reduce(clients, (items, client) => {
    each(client.programs, (program) => {
      items.push({
        ...program,
        client_id: client.id,
        client_name: client.name,
      });
    });
    return items;
  }, []);
  let hasCollector = false;

  const refs = reduce(getTVCollectorRefs(state), (items, rfs, clientId) => {
    items[clientId] = {};
    each(rfs, (collectors, programId) => {
      items[clientId][programId] = {};
      each(collectors, (collector) => {
        hasCollector = true;
        items[clientId][programId][collector.collector_id] = collector.collector_name;
      });
    });
    return items;
  }, {});

  return {
    viewableDimensions: getViewableDimensions(state),
    mappings,
    refs,
    hasCollector,
  };
}

MappingTable.propTypes = {
  dispatch: PropTypes.func.isRequired,
  programs: PropTypes.shape({}).isRequired,
  mappings: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  refs: PropTypes.shape({}).isRequired,
  hasCollector: PropTypes.bool.isRequired,
  viewableDimensions: PropTypes.shape({
    height: PropTypes.number,
  }).isRequired,
};
MappingTable.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(MappingTable);
